import React from 'react';

const Footer = () => (
  <div className="">
    <p className="m-6 text-center text-gray-700 dark:text-gray-200">
      © 2022 All rights reserved by Shoppy.com
    </p>
  </div>
);

export default Footer;
